module.exports = __webpack_public_path__ + "static/media/pasted image 0.bc482ad0.png";